import { render } from "./Loader.vue?vue&type=template&id=5e9163e2&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=5e9163e2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9163e2"]])

export default __exports__